<template>
    <div class="tabs-box">
        <el-tabs  type="card">
            <el-tab-pane :label="title" name="first"></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    export default {
        name: '',
        data() {
            return {
                
            }
        },
        props:{
            title:{
                type:String,
                default:''
            }
        }
    }
</script>

<style lang="scss">
    .tabs-box .el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
        border-bottom: 1px solid #E4E7ED;
    }
    .el-tabs__item.is-top{
        color:#2930f2;
    }
</style>